import { render, staticRenderFns } from "./archive-in.vue?vue&type=template&id=4c8d3f2a&scoped=true"
import script from "./archive-in.vue?vue&type=script&lang=js"
export * from "./archive-in.vue?vue&type=script&lang=js"
import style0 from "./archive-in.vue?vue&type=style&index=0&id=4c8d3f2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8d3f2a",
  null
  
)

export default component.exports